import React from 'react';

const ArrowOpenIcon = () => (
	<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M6.76081 10.4858L2.30579 5.69066C1.43319 4.70666 2.61938 3.37018 3.47494 4.33215L7.50047 8.67572L11.5703 4.30645C12.3645 3.41057 13.5303 4.79111 12.7327 5.69067L8.26741 10.4969C7.72885 11.1174 7.40163 11.2202 6.76081 10.4858Z" fill="#4F6288" />
	</svg>
);

export default ArrowOpenIcon;
